import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { FaStar } from 'react-icons/fa'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useRef, useState } from 'react'
import { RequestProvider } from '../../../context/RequestContext'
import { Services } from '../../../components/index/service/Services'
import { AnimatePresence, motion } from 'framer-motion'
import { getWpNewHouseKeeping, setWpNewHouseKeeping } from '../../../service/wp-blogs-store'
import { getWpNewPostsByCategory } from '../../../lib/service'
import { PartTimeHelperBooking } from '../../../components/index/service-category/domestic-service/PartTimeHelperBooking'
import { getAppSettings } from '../../../api/app-setting/app-setting'
import { SystemError } from '../../../components/error/SystemError'
import { openModal } from '../../../service/modal-service'
import { helperCostCalculation } from '../../../js/part-time-helper-cost'
import { helperTestimonials } from '../../../data/CustomerReviewData'

export async function getStaticProps() {
    const countryCd = "sg"
    const countryName = "Singapore"
    
    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Domestic Services")
    
    const lat = 1.3521
    const lng = 103.8198

    const { modifiedDate, month, year } = getArticleDateTime()
    const houseKeepingBlogs = blogsMaster['house-keeping'].blogArray;
    const wpNewPosts = getWpNewHouseKeeping().length > 0 ?  getWpNewHouseKeeping() : await getWpNewPostsByCategory(6, "house-keeping");
    setWpNewHouseKeeping(wpNewPosts)
    
    const currencyCd = "SGD"

    let helperService = []
    let babySitterService = []
    let elderlyCareService = []
    let cookingAssistanceService = []  
    
    helperCostCalculation(currencyCd, helperService, babySitterService, elderlyCareService, cookingAssistanceService)

    return {
        props: {
            requestCategorySettings,
            modifiedDate,
            month,
            year,
            houseKeepingBlogs,
            wpNewPosts,
            currencyCd,
            helperService,
            elderlyCareService,
            helperTestimonials,
            countryName
        },
        // Next.js will attempt to re-generate the page:
        // - When a request comes in
        // - At most once every 10 seconds
        revalidate: 259200, // In seconds
    }
}
export default function Home(props) {
    const router = useRouter()
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const houseKeepingBlogs = props.houseKeepingBlogs
    const wpNewPosts = props.wpNewPosts
    const requestCategorySettings = props.requestCategorySettings;
    const testimonials = props.helperTestimonials
    const maxRating = [1, 2, 3, 4, 5]
    const requestType = 'Domestic Services'
    const countryName = props.countryName
    const currencyCd = props.currencyCd
    const helperService = props.helperService
    const elderlyCareService = props.elderlyCareService

    const [ requestForm, setRequestForm ] = useState(router.query.requestForm)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    
    const [ isShowJobScope, setIsShowJobScope ] = useState(false)
    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""})

    useEffect(() => {
        setRequestForm(router.query.requestForm)
    }, [router.query.requestForm])

    const videoRef = useRef();

    useEffect(() => {    
        if(requestForm) return
        videoRef.current.play()
    }, [requestForm])

    const fetchAppSetting = useCallback(async() => {
        try {
            const appSettings = await getAppSettings(countryName)
            setWaInd(appSettings.waBusinessInd)
        } catch (error) {
            console.log(error);
        }
    }, [countryName])

    useEffect(() => {
        if(!countryName) return

        fetchAppSetting()
    }, [countryName, fetchAppSetting])

    const showJobScope = () =>{
        setErrorContent({'header': "Service Inclusions", 'isInfo': true, 'body': "Kitchen Assistance - Dishwashing, countertop wiping, and organizing for a tidy kitchen.\n\nHousekeeping - Sweeping/vacuuming, mopping, dusting, sanitizing, toilet cleaning, indoor side of window cleaning and maintaining overall home cleanliness.\n\nBabysitting, nanny & elderly care service.\n\nNote: The helper will not be carrying any equipment.\nThis service is for residential premises only."});
        openModal(setIsSystemError)
    }

  return (
    <>
      <Head>
        <title>Part Time Babysitter Singapore | Affordable Hourly Nanny</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Hire trusted part-time babysitter services in Singapore with StringsSG. Flexible schedules, qualified caregivers, and transparent hourly rates for personalized childcare."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/part-time-cleaner-singapore/part-time-babysitter-singapore" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Part Time Babysitter Singapore | Affordable Hourly Nanny`}/>
        <meta property="og:description" content="Hire trusted part-time babysitter services in Singapore with StringsSG. Flexible schedules, qualified caregivers, and transparent hourly rates for personalized childcare." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-26T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/part-time-helper/babysitter-with-girl.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/part-time-helper/babysitter-with-girl.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/part-time-cleaner-singapore/part-time-babysitter-singapore"/>
        <meta name="twitter:title" content={`Part Time Babysitter Singapore | Affordable Hourly Nanny`}/> 
        <meta name="twitter:description" content="Hire trusted part-time babysitter services in Singapore with StringsSG. Flexible schedules, qualified caregivers, and transparent hourly rates for personalized childcare."/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/part-time-cleaner-singapore/part-time-babysitter-singapore"},"headline":"Part Time Babysitter Singapore | Affordable Hourly Nanny","description":"Hire trusted part-time babysitter services in Singapore with StringsSG. Flexible schedules, qualified caregivers, and transparent hourly rates for personalized childcare.","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/part-time-helper/babysitter-with-girl.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-26T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"part-time-helper","item":"https://www.stringssg.com/sg/part-time-cleaner-singapore"},{"@type":"ListItem","position":2,"name":"babysitter"}]}]}`
          }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/part-time-cleaner-singapore/part-time-babysitter-singapore"/>
        </Head>
        <section id="babysitter-singapore" className='relative'>
            <div className="-mt-14 relative w-full aspect-video sm:h-180 overflow-hidden">
                {/* Mobile Video */}
                <video
                    ref={videoRef}
                    className="absolute inset-0 w-full h-full object-cover sm:hidden"
                    poster={s3Static + "blog/living/part-time-helper/babysitter-with-girl-1920-1080.jpg"}
                    title="Part-time babysitter in Singapore"
                    muted
                    loop
                    playsInline
                    preload="metadata"
                >
                    <source src="/video/part-time-helper-web.mp4" />
                    <source src="/video/part-time-helper-web.mov" />
                </video>

                {/* Desktop Image */}
                <Image
                    src={s3Static + "blog/living/part-time-helper/babysitter-with-girl.jpg"}
                    fill
                    className="hidden sm:block object-cover"
                    alt="Part-time babysitter in Singapore"
                    priority={false}
                    quality={100}
                    sizes="100vw"
                />
            </div>
            <RequestProvider>
                <div id="campaign" className='relative bg-gray-100 sm:bg-transparent sm:text-white w-full py-2 sm:absolute sm:top-1/2 sm:-translate-y-1/2'>
                    <PartTimeHelperBooking requestCategorySettings={requestCategorySettings} helperService={helperService} elderlyCareService={elderlyCareService}
                        setRequestForm={setRequestForm} setIsQuickBook={setIsQuickBook} countryName={countryName} currencyCd={currencyCd} helperType="Babysitter" showJobScope={setIsShowJobScope}/>
                </div>
                {requestForm &&
                    <Services requestType={requestType} requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} isQuickBook={isQuickBook} asSheet/>
                }      
            </RequestProvider>  
        </section>
        <div className='max-w-4xl mx-auto py-10 px-2 space-y-8'>
            <div className='space-y-2 text-center '>
                <h1 className='text-3xl md:text-4xl font-semibold'>
                    Part Time Babysitter Singapore | Affordable Hourly Nanny
                </h1>
                {/* <div className='text-gray-400 text-xs'>
                    <time dateTime={modifiedDate}>Updated - {new Date(modifiedDate).toUTCString().substring(0,16)}</time>
                </div>                     */}
            </div>
            <div className='leading-8 space-y-3'>
                <p>
                    StringsSG aims to provide exceptional part-time babysitting services tailored to your family&apos;s needs. Trust us to 
                    care for your little ones while you focus on your commitments.
                </p>
                <p>                        
                    At StringsSG, we understand the importance of reliable and caring childcare. Our part-time babysitter services 
                    offer you peace of mind, knowing that your children are in safe and capable hands while you attend to your 
                    commitments.                        
                </p>
            </div>                
        </div>
        <div className='max-w-4xl mx-auto py-10'>
            <h2 className='text-xl md:text-2xl text-center uppercase'>
                <strong>Our Babysitting Process</strong>
            </h2>
            <div className='mt-10 text-sm leading-7 space-y-5'>      
                <div className='bg-slate-200 px-2 py-5 text-center h-full'>
                    <h3 className='text-base'><strong>1. Initial Consultation</strong></h3>
                    <p className='py-5 max-w-3xl mx-auto'>
                        We begin with a consultation to understand your child&apos;s routine, preferences, and any specific requirements, ensuring personalized care.
                    </p> 
                </div>
                <div className='px-2 py-5 text-center h-full'>
                    <h3 className='text-base'><strong>2. Engaging Activities</strong></h3>
                    <div className='py-5 max-w-3xl mx-auto'>
                        Our babysitters engage your children in age-appropriate and stimulating activities, fostering growth and development in a fun and safe environment.
                    </div> 
                </div>
                <div className='bg-slate-200 px-2 py-5 text-center h-full'>
                    <h3 className='text-base'><strong>3. Safety and Supervision</strong></h3>
                    <p className='py-5 max-w-3xl mx-auto'>
                        Ensuring a secure environment is our priority. Our babysitters maintain constant supervision while creating a warm and nurturing atmosphere.
                    </p> 
                </div>
                <div className='px-2 py-5 text-center h-full'>
                    <h3 className='text-base'><strong>4. Communication and Updates</strong></h3>
                    <div className='py-5 max-w-3xl mx-auto'>
                        We keep you informed about your child&apos;s activities and well-being, maintaining open communication for your peace of mind.
                    </div> 
                </div>
            </div>
        </div> 
        <div className='h-120 py-8 relative bg-black'>
            <h2 className='text-2xl md:text-3xl text-center px-2 uppercase text-white absolute left-0 right-0 z-10 top-10'>
                <strong>Why us?</strong>
            </h2>
            <Image className='opacity-40'
                src={s3Static + "blog/living/part-time-helper/indonesian-maid.jpg"}
                fill
                style={{objectFit: 'cover', objectPosition: 'center'}}   
                placeholder='blur'
                blurDataURL={s3Static + "placeholder.png"}
                alt='Affordable Part Time Helper Service - StringsSG'
            /> 
            <div className='text-white py-20 leading-8'>
                <Carousel autoPlay={true} infiniteLoop={true} showThumbs={false} showStatus={false} interval={5000} preventMovementUntilSwipeScrollTolerance={true} swipeScrollTolerance={50}>
                    <div className='px-6 py-10 h-full'>
                        <h3 className='text-xl'><strong>Instant Booking</strong></h3>
                        <p className='py-5 max-w-3xl mx-auto'>
                            Our platform allows for instant booking, providing immediate access to a pool of vetted and skilled babysitters.
                        </p> 
                    </div>
                    <div className='px-6 py-10 h-full'>
                        <h3 className='text-xl'><strong>Best Helper Service Quality</strong></h3>
                        <div className='py-5 max-w-3xl mx-auto'>
                            We have onboarded highly ethical and diligent team of part-time helpers on our platform, and have standardized the service quality.
                        </div> 
                    </div>
                    <div className='px-6 py-10 h-full'>
                        <h3 className='text-xl'><strong>Affordable</strong></h3>
                        <p className='py-5 max-w-3xl mx-auto'>
                            Our platform provides you with the best pricing based on a dynamic cost calculation algorithm for your requirements.
                        </p> 
                    </div>
                    <div className='px-6 py-10 h-full'>
                        <h3 className='text-xl'><strong>Customer Service</strong></h3>
                        <p className='py-5 max-w-3xl mx-auto'>
                            Use the live chat feature on the app to initiate conversation with the assigned service team.
                        </p> 
                    </div>
                </Carousel>      
            </div>
        </div>
        <div className='max-w-4xl mx-auto py-10 px-2 text-sm'>
            <h2 className='text-xl md:text-2xl text-center uppercase py-5'>
                <strong>5 Benefits Of Hiring A Babysitter</strong>
            </h2>
            <div className='py-4 grid grid-cols-1 md:grid-cols-2 gap-2'>
                <div className='relative w-full h-96'>
                    <Image
                        src={s3Static + "blog/living/part-time-helper/part-time-babysitter.jpg"}
                        fill
                        style={{objectFit: 'cover'}}
                        alt='part-time babysitter'
                        placeholder="blur"
                        blurDataURL={s3Static + "placeholder.png"}
                    />
                </div>
                <div className='flex items-center'>
                    <div className='space-y-2 leading-7'>
                        <div>
                            <h3><strong>1. Personalized Attention</strong></h3>
                            <p>
                                A babysitter provides individualized care, catering to your child&apos;s specific needs and interests. This 
                                one-on-one attention fosters a nurturing environment for optimal growth and development.
                            </p>
                        </div>
                        <div>
                            <h3><strong>2. Flexibility in Schedules</strong></h3>
                            <p>
                                With a babysitter, you gain the flexibility to attend appointments, run errands, or enjoy a night out 
                                while ensuring your child receives quality care. They adapt to your schedule, providing assistance when 
                                you need it most.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='py-4 grid grid-cols-1 md:grid-cols-2 md:space-x-2 space-y-2'>
                <div className='relative w-full h-96 md:hidden'>
                    <Image
                        src={s3Static + "blog/living/part-time-helper/smiling-babysitter.jpg"}
                        fill
                        style={{objectFit: 'cover'}}
                        alt='Babysitter piggy backing'
                        placeholder="blur"
                        blurDataURL={s3Static + "placeholder.png"}
                    />
                </div>
                <div className='flex items-center'>
                    <div className='space-y-2 leading-7'>
                        <div>
                            <h3><strong>3. Reliable Support System</strong></h3>
                            <p>
                            Babysitters offer a reliable support system, providing assistance during busy or challenging times. 
                            Whether it&apos;s occasional care or regular part-time help, they become a dependable resource for your family.
                            </p>
                        </div>
                        <div>
                            <h3><strong>4. Introducing New Activities and Learning</strong></h3>
                            <p>
                            Babysitters engage children in enriching activities, encouraging learning and creativity. They introduce new games, 
                            hobbies, and educational experiences that complement your child&apos;s interests and development.
                            </p>
                        </div>
                    </div>
                </div>
                <div className='relative w-full h-96 hidden md:flex'>
                    <Image
                        src={s3Static + "blog/living/part-time-helper/smiling-babysitter.jpg"}
                        fill
                        style={{objectFit: 'cover'}}
                        alt='Babysitter piggy backing'
                        placeholder="blur"
                        blurDataURL={s3Static + "placeholder.png"}
                    />
                </div>
            </div>
            <div className='space-y-2 leading-7'>
                <h3><strong>5. Peace Of Mind for Parents</strong></h3>
                <p>
                    Hiring a babysitter gives parents peace of mind knowing that a responsible and trustworthy individual is caring for their child. 
                    It allows parents to focus on work or personal commitments without worrying about their child&apos;s well-being.
                </p>
            </div>
        </div>          
        <div className='max-w-4xl mx-auto py-10 space-y-5 px-4 leading-7 text-sm'>
            <h2 className='text-xl md:text-2xl text-center uppercase'>
                <strong>Hourly Rates Of Babysitter In Singapore</strong>
            </h2>
            <p className='pt-5'>
                In general, hourly rates for babysitters in Singapore range from $20 to $30 per hour based on market 
                research. However, it&apos;s crucial for families to consider the factors mentioned below when 
                determining the rates they are willing to pay and to choose a babysitter whose qualifications and services align with 
                their needs.
            </p>
            <div>
                <h3 className='text-lg'><strong>Experience and Qualifications:</strong></h3>
                <p>
                    Hourly rates for babysitters often vary based on their experience and qualifications. Babysitters with certifications in 
                    early childhood education or specialized training might command higher rates due to their enhanced skill sets.
                </p>
            </div>
            <div>
                <h3 className='text-lg'><strong>Scope of Services:</strong></h3>
                <p>
                    The hourly rate can also depend on the services offered. Babysitters providing additional services such as 
                    tutoring, meal preparation, or specific care for children with special needs may charge differently based on 
                    the additional responsibilities.
                </p>
            </div>
            <div>
                <h3 className='text-lg'><strong>Market Demand:</strong></h3>
                <p>
                In Singapore, hourly rates for part-time babysitters may fluctuate based on market demand. During peak times, such as weekends or 
                holidays, rates might be slightly higher due to increased demand for babysitting services.
                </p>
            </div>
            <div>
                <h3 className='text-lg'><strong>Geographical Location:</strong></h3>
                <p>
                Hourly rates can also vary depending on the location within Singapore. Rates might differ between urban and suburban areas, 
                considering differences in living expenses and market demands.
                </p>
            </div>
            <div>
                <h3 className='text-lg'><strong>Client-Specific Needs:</strong></h3>
                <p>
                Hourly rates may differ based on the specific needs of the child or family. Babysitters might charge differently if additional 
                duties or care requirements are necessary.
                </p>
            </div>
            <div>
                <h3 className='text-lg'><strong>Customized Packages and Duration:</strong></h3>
                <p>
                Some babysitters or agencies offer customized packages or discounts for longer-term commitments or regular schedules, allowing 
                families to benefit from reduced hourly rates for extended periods.
                </p>
            </div>
            <div>
                <h3 className='text-lg'><strong>Transparency and Communication:</strong></h3>
                <p>
                Reputable agencies or babysitters usually maintain transparency in their pricing structures, ensuring that families understand the rates and any additional fees upfront.
                </p>
            </div>
        </div>
        <div className='max-w-5xl mx-auto text-center py-10 relative'>
            <div className='relative w-full h-96'>
                <Image
                    src={s3Static + "blog/living/part-time-helper/maid-baby-sitting.jpg"}
                    fill
                    style={{objectFit: 'cover', objectPosition: ''}} 
                    placeholder='blur'
                    blurDataURL={s3Static + "placeholder.png"}
                    alt='Babysitter helping with breakfast - StringsSG'
                />     
            </div> 
            <div className='absolute flex items-center text-white top-0 bottom-0 left-0 right-0 w-fit mx-auto rounded-3xl'>
                <Link href="/sg/part-time-cleaner-singapore" prefetch={false} className='p-4 rounded-lg bg-black/60 text-xl md:text-2xl'>
                        Hire Babysitter
                </Link>       
            </div>  
        </div>  
        <BlogsList blogs={houseKeepingBlogs} wpPosts={[]} wpNewPosts={wpNewPosts}/>
        <AnimatePresence>
            {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
        </AnimatePresence>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}